// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

ion-content {
  flex: 1;
  min-height: 0;
}

.chart-section {
  flex-shrink: 0;
}

.chart-section app-bar-chart,
.chart-section app-pie-chart {
  height: 280px;
}

.chart-section app-bar-chart {
  height: auto;
  min-height: 280px;
}

.segmento-giorni,
.segmento-periodo {
  width: auto;
  flex: none;
}
.segmento-giorni ion-segment-button,
.segmento-periodo ion-segment-button {
  min-width: 56px;
  max-width: 96px;
}

.widget-section {
  flex-shrink: 0;
}

.kpi-unita {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--ion-color-medium);
}

.kpi-variazione {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--ion-color-medium);
}

.kpi-altre {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 10px;
  margin: 2px 0 0;
  font-size: 0.75rem;
  color: var(--ion-color-medium);
}

ion-card {
  margin-inline: 0;
}

::ng-deep app-bar-chart ion-card,
::ng-deep app-pie-chart ion-card {
  --background: var(--ion-card-background);
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard-home/dashboard-home.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAGA;EACE,OAAA;EACA,aAAA;AAAF;;AAKA;EACE,cAAA;AAFF;;AAKA;;EAEE,aAAA;AAFF;;AAKA;EAEE,YAAA;EACA,iBAAA;AAHF;;AAOA;;EAEE,WAAA;EACA,UAAA;AAJF;AAME;;EACE,eAAA;EACA,eAAA;AAHJ;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,iBAAA;EACA,gBAAA;EACA,8BAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,8BAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;AAJF;;AAQA;EACE,gBAAA;AALF;;AASA;;EAEE,wCAAA;AANF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n// senza flex:1 ion-content collassa ad altezza auto; h-full interno non funziona\nion-content {\n  flex: 1;\n  min-height: 0;\n}\n\n// Feature 161 (research R11): grafici ad altezza fissa e pagina che scorre anche su desktop, così i widget\n// sotto i grafici non li schiacciano.\n.chart-section {\n  flex-shrink: 0;\n}\n\n.chart-section app-bar-chart,\n.chart-section app-pie-chart {\n  height: 280px;\n}\n\n.chart-section app-bar-chart {\n  // la riga di link ai giorni sta sotto il grafico\n  height: auto;\n  min-height: 280px;\n}\n\n// Senza un limite i bottoni di ion-segment si allargano fino al loro massimo (360px) e il selettore copre il titolo.\n.segmento-giorni,\n.segmento-periodo {\n  width: auto;\n  flex: none;\n\n  ion-segment-button {\n    min-width: 56px;\n    max-width: 96px;\n  }\n}\n\n.widget-section {\n  flex-shrink: 0;\n}\n\n.kpi-unita {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--ion-color-medium);\n}\n\n.kpi-variazione {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--ion-color-medium);\n}\n\n.kpi-altre {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px 10px;\n  margin: 2px 0 0;\n  font-size: 0.75rem;\n  color: var(--ion-color-medium);\n}\n\n// Azzera solo i margini orizzontali di Ionic, lasciando invariati quelli verticali (mb-2 ecc.)\nion-card {\n  margin-inline: 0;\n}\n\n// Override background dei grafici embedded (non raggiungibile via Tailwind)\n::ng-deep app-bar-chart ion-card,\n::ng-deep app-pie-chart ion-card {\n  --background: var(--ion-card-background);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
